import {RegistrationRequest} from '@/store/models';
import redirectToLocation from '@/commons/redirectManager';
import {bus} from './bus';

const event = 'user.registrationsuccess';

export default event;

bus.$on(
    event,
    (payload: {result: boolean; request: RegistrationRequest; userToken: string; recaptchaToken?: string}) => {
        if (payload.result) {
            redirectToLocation('/checkout/shipping', true);
        }
    }
);
